import { useCollectionStoreProps as e } from "./AMMIPFT4.js";
import { useStoreProps as c } from "./RTNCFSKZ.js";
function l(i, t, u) {
  return i = e(i, t, u), c(i, u, "activeId", "setActiveId"), c(i, u, "includesBaseElement"), c(i, u, "virtualFocus"), c(i, u, "orientation"), c(i, u, "rtl"), c(i, u, "focusLoop"), c(i, u, "focusWrap"), c(i, u, "focusShift"), i;
}
export {
  l as useCompositeStoreProps
};
//# sourceMappingURL=B7UTNDHN.js.map
